/**
 * Konsertene mine (sak 216, 0380). Globale nøkler: de gjelder mennesket, ikke huset som er aktivt.
 *
 * Bare lista. Den enkelte konserten åpnes i programposten, den ene advancen (Del 1 B.1, `ConcertPage`).
 */
import { concertListSchema, type ConcertList } from '@tvitvi/shared';
import { queryOptions } from '@tanstack/react-query';

import { CACHE } from '@/api/cache-tiers';
import { apiRequest } from '@/api/client';
import { qk } from '@/api/query-keys';

export function myConcertsQueryOptions() {
  return queryOptions({
    queryKey: qk.myConcerts(),
    queryFn: ({ signal }): Promise<ConcertList> =>
      apiRequest({ path: '/me/concerts', schema: concertListSchema, signal }),
    ...CACHE.list,
  });
}
